import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

// material-ui
import ButtonBase from '@mui/material/ButtonBase'

// project imports
import { Box } from '@mui/system'
import { menuOpen } from '../../../../app/features/customization/customizationSlice'
import { useAppSelector, useHasPermission } from '../../../../app/hooks'
import { customTheme } from '../../../../app/selectedStore'
import { images } from '../../../../assets/images'
import { config, PERMISSION } from '../../../../constants'
import { Perm_Order_Menu_View, Perm_Order_Menu_View_Kt } from '../../../../app/hooks/premissionScreen'
import ROUTES from '../../../../routers/helpersRouter/constantRouter'

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useAppSelector(customTheme)
  const dispatch = useDispatch()
  const permOrderView = useHasPermission(Perm_Order_Menu_View)
  const permOrderViewKT = useHasPermission(Perm_Order_Menu_View_Kt)
  const permCOORDINATION = useHasPermission([PERMISSION.COORDINATION])
  const checkLink = () => {
    if (permOrderView) return `${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST}`
    if (permOrderViewKT) return `${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_LIST_KT}`
    if (permCOORDINATION) return `${ROUTES.ORDER}/${ROUTES.ORDER_CHILD.ORDER_TRANSPORTCOORDINATION}`
    return config.defaultPath
  }
  return (
    <ButtonBase disableRipple onClick={() => dispatch(menuOpen({ id: defaultId }))} component={Link} to={checkLink()}>
      <Box
        component='img'
        sx={{
          height: 60,
          width: '100%`',
          maxHeight: { xs: 60, md: 60 },
          maxWidth: { xs: '100%', md: '100%' }
        }}
        alt='Logo'
        src={images.logoString}
      />
    </ButtonBase>
  )
}

export default LogoSection
